import { FC } from "react";
import { Box } from "@mui/material";
import { EditorAddOrEdit } from "../EditorAddOrEdit/EditorAddOrEdit";
import { ETBAS } from "../emailTemplateBuilder.classes";

export const AddSection: FC = () => {
  return (
    <Box className={ETBAS.page}>
      <EditorAddOrEdit />
    </Box>
  );
};
